import { render, staticRenderFns } from "./cSwiper.vue?vue&type=template&id=fd16e7e8"
import script from "./cSwiper.vue?vue&type=script&lang=js"
export * from "./cSwiper.vue?vue&type=script&lang=js"
import style0 from "./cSwiper.vue?vue&type=style&index=0&id=fd16e7e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports